export const getUrl = ( hostname, locale, defaultLocale, asPath ) => `https://${ hostname }${ locale === defaultLocale ? '' : `/${ locale }` }${ asPath }`
